/**************************************************************************
 * File: index.ts
 * Notes: Base javascript script used to import client js libraries and
 * initialize application. All extended application is found in
 * application.js
 **************************************************************************/

const MINDBREEZE_IMPORTS = [
  'api/v2/api',
  'client/application',
  'i18n/i18n',
  'model/properties',
  'backbone',
  'jquery'  
];

Mindbreeze['require'](MINDBREEZE_IMPORTS, () => {
  const Application = require('./application').default;
  Application.launch();
});

